const Theme = {
  logo_image_url: 'courantlevis.png',
  logo_height: 85,
  token_url: 'courantlevis.png',
  number_hidden: true,

  body_background_color: '#007dc3',

  button_color: '#00A79D',
  button_radius: 50,
  button_half_border_color: '#00A79D',

  text_font: `'Montserrat', sans-serif`,
  title_font: `'Montserrat', sans-serif`,
  title_italic: true,
}

export default Theme
